import { useState, useEffect, Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { PageSkeleton } from './Skeletons';

const RAIL_KEY = 'snd-rail-collapsed';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(RAIL_KEY) === '1');
  const location = useLocation();

  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  useEffect(() => {
    const handleEscape = (e) => { if (e.key === 'Escape') setSidebarOpen(false); };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  const toggleCollapse = () => {
    setCollapsed((c) => {
      localStorage.setItem(RAIL_KEY, c ? '0' : '1');
      return !c;
    });
  };

  return (
    <div className="min-h-screen">
      {sidebarOpen && (
        <div className="mobile-overlay animate-fade-in" onClick={() => setSidebarOpen(false)} />
      )}

      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapse}
      />

      <div
        className={`main-content transition-[padding] duration-200 ${collapsed ? 'lg:pl-[68px]' : 'lg:pl-64'}`}
      >
        <Navbar onMenuClick={() => setSidebarOpen(true)} />
        <main className="px-3 py-5 lg:px-6 lg:py-6">
          <div className="mx-auto w-full max-w-[1700px]">
            <Suspense fallback={<PageSkeleton />}>
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
